import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { RUN_TWN } from "utils/mutations";
import ReactJson from "react-json-view";

const TWNTable = ({ user = {} }) => {
  const [error, setError] = useState("");
  const [twnData, setTwnData] = useState(null);
  const [runWorkNumber, { data, loading }] = useMutation(RUN_TWN);
  const [hasExistingTWN, setHasExistingTWN] = useState(!!(JSON.parse(user.metadata || "{}")).twnId);

  const fetchTWNData = ({ forceNewTWN = false }) => {
    if (loading) { return; }
    runWorkNumber({
      variables: {
        userId: user.email,
        forceNewTWN,
      } })
      .then((res) => {
        const { status, message, payload } = ((res || {}).data || {}).runTWN || {};
        if (status !== "OK"){
          setError(message);

        } else {
          setTwnData(JSON.parse(payload));
          setHasExistingTWN(true);
        }
      })
      .catch((err) => {
        console.log('error fetching twn data');
        setError("Error fetching data");
      });
  };

  return (
    <div className='my-5'>
      <h1 className="text-2xl font-title mb-2 font-light">TWN Data</h1>
      <div>User {hasExistingTWN ? "has" : "does not have"} existing TWN Profile</div>
      {error && <div className="text-red-500">{error}</div>}
      {
        twnData ?
          (
            <div>
              <ReactJson
                src={twnData}
                name="TWNData"
                theme="summerfruit:inverted"
                iconStyle="circle"
                collapsed={2}
                displayDataTypes={false}
                enableClipboard={false}
              />
              <span className="mx-5 text-base">
                <button
                  className="btn btn-green border-0 cursor-pointer py-1 m-2 text-sm"
                  type="button"
                  onClick={() => fetchTWNData({ forceNewTWN: true })}
                  disabled={loading}
                >
                  {loading ? (
                    <i className="fas fa-sync fa-spin ml-2" />
                  ) : (
                    `Force New TWN`
                  )}
                </button>
              </span>
            </div>
          ) : (
            <div>
              <span className="mx-5 text-base">
                <button
                  className="btn btn-green border-0 cursor-pointer py-1 m-2 text-sm"
                  type="button"
                  onClick={fetchTWNData}
                  disabled={loading}
                >
                  {loading ? (
                    <i className="fas fa-sync fa-spin ml-2" />
                  ) : (
                    `${hasExistingTWN ? "Fetch" : "Run New"} TWN`
                  )}
                </button>
              </span>
            </div>
          )
      }
    </div>
  );
};

export default TWNTable;
